import { useState } from 'react'
import { Routes, Route, Navigate, useLocation } from 'react-router-dom'
import Header from './components/Header.jsx'
import Footer from './components/Footer.jsx'
import LiveRail from './components/LiveRail.jsx'
import SplashScreen from './components/SplashScreen.jsx'
import { useAuth } from './context/AuthContext.jsx'

import Home from './pages/Home.jsx'
import CaseOpen from './pages/CaseOpen.jsx'
import Crafts from './pages/Crafts.jsx'
import Upgrade from './pages/Upgrade.jsx'
import Inventory from './pages/Inventory.jsx'
import Deposit from './pages/Deposit.jsx'
import Profile from './pages/Profile.jsx'
import Login from './pages/Login.jsx'
import Register from './pages/Register.jsx'
import Legal from './pages/Legal.jsx'
import NotFound from './pages/NotFound.jsx'

/** Закрывает страницу от неавторизованных, запоминая, куда человек шёл. */
function Protected({ children }) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="page container">
        <div className="skeleton" style={{ height: 320 }} />
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />
  }

  return children
}

export default function App() {
  const [initialLoading, setInitialLoading] = useState(true)

  return (
    <>
      {initialLoading && (
        <SplashScreen onComplete={() => setInitialLoading(false)} />
      )}
      <div className="shell shell-rail">
        <Header />
        <LiveRail />
      <Routes>
        <Route path="/" element={<Home />} />
        {/* Главная и каталог кейсов — одна и та же витрина. Ссылок на /cases
            по проекту много, и это привычный адрес: оставляем оба пути. */}
        <Route path="/cases" element={<Home />} />
        <Route path="/cases/:id" element={<CaseOpen />} />
        <Route path="/case/:id" element={<CaseOpen />} />
        <Route path="/containers/:id" element={<CaseOpen />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        <Route path="/crafts" element={<Crafts />} />
        <Route path="/upgrade" element={<Upgrade />} />
        <Route path="/inventory" element={<Inventory />} />
        <Route
          path="/deposit"
          element={
            <Protected>
              <Deposit />
            </Protected>
          }
        />
        <Route
          path="/profile"
          element={
            <Protected>
              <Profile />
            </Protected>
          }
        />
        <Route path="/fair" element={<Navigate to="/" replace />} />
        <Route path="/terms" element={<Legal />} />
        <Route path="/privacy" element={<Legal />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
      <Footer />
    </div>
    </>
  )
}
